export default __webpack_public_path__ + "static/media/click1.d827cb4a.wav";